import React from 'react';
import { STag, STooltip } from '@avalara/skylab-sdk/react';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import { InvoiceStatusColorMap, COUNTABLE_INVOICE_STATUSES, resolveInvoiceStatusKey, getInvoiceStatusLabel, getDocumentCounts } from '../../../utils/uploadedDocumentsHelper';

// Order of the stacked rows in the counts tooltip.
const COUNT_ROWS = Object.freeze([
    { key: 'processed', labelString: 'uploadedDocuments_processed' },
    { key: 'error', labelString: 'uploadedDocuments_error' },
    { key: 'onhold', labelString: 'uploadedDocuments_onHold' },
    { key: 'inbox', labelString: 'uploadedDocuments_pending' }
]);

const renderTooltipContent = (counts, languages) => {
    if (!counts) {
        return <span slot="content">{LANGUAGES_CONTROLLER.format(languages, 'uploadedDocuments_countsNotAvailable')}</span>;
    }

    return (
        <div slot="content" style={{ display: 'block', minWidth: '10rem' }}>
            {COUNT_ROWS.map(({ key, labelString }) => (
                <span key={key} style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                    <span>{LANGUAGES_CONTROLLER.format(languages, labelString)}:</span>
                    <span>{counts[key]}</span>
                </span>
            ))}
            <span style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginBlockStart: '0.25rem', paddingBlockStart: '0.25rem', borderBlockStart: '1px solid currentColor', fontWeight: 'bold' }}>
                <span>{LANGUAGES_CONTROLLER.format(languages, 'uploadedDocuments_totalNumber')}:</span>
                <span>{counts.total}</span>
            </span>
        </div>
    );
};

const InvoiceStatusTag = ({ document, showCounts, languages }) => {
    const statusKey = resolveInvoiceStatusKey(document.invoiceStatus);
    const statusLabel = getInvoiceStatusLabel(languages, statusKey);
    const statusColor = InvoiceStatusColorMap[statusKey];

    if (!statusLabel) {
        return null;
    }
    const tagId = showCounts ? `invoice-status-tag-${document.id}` : undefined;
    const hasCounts = COUNTABLE_INVOICE_STATUSES.has(statusKey);
    const counts = tagId && hasCounts ? getDocumentCounts(document) : null;

    return (
        <div className="flex align-items-center">
            <STag
                id={tagId}
                color={statusColor}
                style={{ minWidth: '7rem', justifyContent: 'center', cursor: tagId ? 'help' : undefined }}
            >
                <span slot="content">{statusLabel}</span>
            </STag>
            {tagId && (
                <STooltip triggerId={tagId} tooltipId={`${tagId}-tooltip`} placement="top">
                    {renderTooltipContent(counts, languages)}
                </STooltip>
            )}
        </div>
    );
};


InvoiceStatusTag.defaultProps = {
    showCounts: false,
    languages: {}
};

export default InvoiceStatusTag;
